var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-button',_vm._g({staticClass:"custom-service-btn",class:{ 'custom-service-btn--bottom': _vm.bottom },attrs:{"text":"","small":""}},_vm.$listeners),[_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }